import React from 'react';
import { Button } from 'primereact/button';
import logger from '../../shared/utils/logger';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        logger.error('ErrorBoundary capturó:', error, info);
    }

    handleRetry = () => {
        this.setState({ hasError: false });
    };

    handleGoHome = () => {
        window.location.href = '/';
    };

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '1.5rem'
                    }}
                >
                    
                    <div className="flex gap-3">
                        <span>Ocurrió un error inesperado.</span>
                        <Button label="Reintentar" onClick={this.handleRetry} />
                        <Button label="Volver al inicio" onClick={this.handleGoHome} severity="secondary" />
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}